import React, {Component}  from 'react'

class HeaderTop extends React.Component{

    state ={className:"" };

    componentDidMount(){
        window.addEventListener("scroll", this.handleScroll);
    }


    render(){

        let scrollStyle=''
        if(this.props.didScroll){
            console.log('scrolled')
            scrollStyle='scrolled'
        }
        return (
            <div>
                <div data-collapse="medium" data-animation="default" data-duration="400" id="Navbar"
                     data-w-id="8e7d6612-01c7-9bb0-1b73-9c98c9ce27b9" role="banner" className={`navbar w-nav ${scrollStyle}`}
                >
                    <div className="navigation-container">
                        <a href="/" aria-current="page" className={`brand w-nav-brand w--current ${scrollStyle}`} aria-label="home">
                            <img
                                className="shape-crisp"
                                src="/resources/image/logo512.png"
                                width="180"
                                sizes="(max-width: 479px) 41vw, (max-width: 767px) 42vw, (max-width: 991px) 260px, 23vw"
                                alt=""/>
                        </a>
                    </div>
                    <div className="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
                </div>
            </div>
        );
    }

}
export default HeaderTop;
